import { Mail, MapPin, Phone } from "lucide-react";
import Logo from "./Logo";

const NAV = [
  { label: "Categories", href: "#categories" },
  { label: "Why Us", href: "#why" },
  { label: "Network", href: "#network" },
  { label: "Inquiry", href: "#inquiry" },
];

const LEGAL = [
  { label: "Privacy Policy", href: "#" },
  { label: "Terms of Trade", href: "#" },
  { label: "Cookie Policy", href: "#" },
];

export default function Footer() {
  return (
    <footer className="border-t-2 border-accent bg-bg">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-10 md:py-12">
        <div className="grid md:grid-cols-3 gap-8">
          <div>
            <div className="mb-4">
              <Logo className="h-14 md:h-16 w-auto max-w-none" />
            </div>
            <p className="text-sm text-muted leading-relaxed max-w-xs">
              India-based import &amp; export trading house — wholesale sourcing, private label, and
              global shipping for six product categories.
            </p>
            <p className="mt-4 flex items-center gap-2 text-sm text-muted">
              <MapPin size={15} className="text-accent shrink-0" />
              India
            </p>
          </div>

          <div>
            <h4 className="label-cap text-primary mb-4">Navigate</h4>
            <ul className="space-y-2">
              {NAV.map((l) => (
                <li key={l.href}>
                  <a href={l.href} className="text-sm text-muted link-underline hover:text-primary">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="label-cap text-primary mb-4">Contact</h4>
            <ul className="space-y-3 text-sm text-muted">
              <li className="flex items-center gap-2">
                <Mail size={16} className="text-accent shrink-0" />
                <a href="mailto:info@bsglobalventures.com" className="hover:text-primary transition-colors">
                  info@bsglobalventures.com
                </a>
              </li>
              <li className="flex items-center gap-2">
                <Phone size={16} className="text-accent shrink-0" />
                <a href="tel:+919004015183" className="hover:text-primary transition-colors">
                  +91 90040 15183
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-border flex flex-col md:flex-row justify-between gap-4 text-xs text-muted">
          <span>© 2025 B&amp;S Global Ventures</span>
          <div className="flex flex-wrap gap-4">
            {LEGAL.map((l) => (
              <a key={l.label} href={l.href} className="hover:text-primary transition-colors">
                {l.label}
              </a>
            ))}
            <a href="/admin/login" className="hover:text-accent transition-colors">
              Admin
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
